import React from "react";
import { TextField, Button } from "@material-ui/core";
import useWidth from "hooks/useWidth";
import { FilterList } from "@material-ui/icons";
import { useStyles } from '../styles/styles';
import { useDispatch } from "react-redux";
import { asyncSummary } from "store/reducers/paymentPlan.reducer";

const Filter = ({startDate, setStartDate, endDate, setEndDate}) => {
    const classes = useStyles();
    const displayWidth = useWidth();
    const isDesktop = displayWidth > 820;
    const dispatch = useDispatch();

    const handleFilter = () => {
      dispatch(asyncSummary({initialDate: startDate, endDate: endDate || startDate}))
    };

  return (
      <div className={classes.filter}>
        <TextField
          id="start-date"
          label="Data inicial"
          variant="outlined"
          type="date"
          className={classes.textField}
          value={startDate}
          onChange={({ target }) => {
            const value = target.value;
            if (/^\d{4}-\d{2}-\d{2}$/.test(value) || value === '') {
              setStartDate(value);
            }
          }}         
          InputLabelProps={{ shrink: true }} 
          size="small"
          error={!startDate || (endDate && startDate > endDate)}
          helperText={!startDate && 'Campo obrigatório'  || (endDate && startDate > endDate) && 'Data inicial não pode ser maior que a data final'}   
          inputProps={{
            max: endDate,
          }}
        />
        <TextField
          id="end-date"
          label="Data final"
          variant="outlined"
          type="date"
          className={classes.textField}
          value={endDate}
          onChange={({ target }) => {
            const value = target.value;
            if (/^\d{4}-\d{2}-\d{2}$/.test(value) || value === '') {
              setEndDate(value);
            }
          }}
          InputLabelProps={{ shrink: true }}
          size="small"
          inputProps={{
            min: startDate,
          }}
        />
        <Button
          aria-label="pesquisar"
          variant="contained"
          color="primary"
          onClick={handleFilter}
          className={classes.filterButton}
          startIcon={<FilterList />}
          disabled={!startDate || endDate && startDate > endDate}
        >
          {isDesktop && 'Filtrar'}
        </Button>        
      </div>
  )
}

export default Filter;